
import axios from 'axios'
import VueCookies from 'vue-cookies'

export default {
  create (data) {
    return axios.post(process.env.API_ENDPOINT + '/company', data)
  },
  show (id) {
    return axios.get(process.env.API_ENDPOINT + '/company/' + id + '?token=' + VueCookies.get('token'))
  },
  update (data, id) {
    return axios.post(process.env.API_ENDPOINT + '/company/' + id + '?token=' + VueCookies.get('token'), data)
  }
}



// WEBPACK FOOTER //
// ./src/store/api/company.js